import { useEffect, useState } from 'react';
import emailjs from 'emailjs-com';
import Banner from '../components/Banner.js';
import Footer from '../components/Footer.js';
import Cartoon from '../components/Cartoon.js';

function ContactPage() {
  const [result, setResult] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [topic, setTopic] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    emailjs.init('STKNujVM2UrHCRAqG');
  });

  const updateField = (update, value) => {
    if (result) setResult(undefined);
    update(value);
  };

  const updateName = (event) => {
    updateField(setName, event.target.value);
  };

  const updateEmail = (event) => {
    updateField(setEmail, event.target.value);
  };

  const updateTopic = (event) => {
    updateField(setTopic, event.target.value);
  };

  const updateMessage = (event) => {
    updateField(setMessage, event.target.value);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setResult('');
    emailjs
      .send('service_71cohue', 'template_197xpwq', {
        name,
        email,
        topic,
        message
      })
      .then(() => {
        setResult('sent!');
        setLoading(false);
        setName('');
        setEmail('');
        setTopic('');
        setMessage('');
      })
      .catch(() => {
        setResult('error!');
        setLoading(false);
      });
  };

  const canSubmit = !loading && name && email && topic && message;

  return (
    <div className="page contact-page">
      <Banner selected="contact" />
      <div className="contents">
        <div className="cartoon-container">
          <Cartoon
            messages={[
              // eslint-disable-next-line quotes
              result ? result : "Let's chat",
              result ? result : 'Fill out the form',
              result ? result : 'Send me an email'
            ]}
            i={0}
          />
        </div>
        <form className="contact-form" onSubmit={onSubmit}>
          <div className="form-section">
            <input
              type="text"
              id="name"
              value={name}
              onChange={updateName}
              required
              disabled={loading}
              data-lpignore="true"
              placeholder="Name"
            />
          </div>
          <div className="form-section">
            <input
              type="email"
              id="email"
              value={email}
              onChange={updateEmail}
              required
              disabled={loading}
              data-lpignore="true"
              placeholder="Email address"
            />
          </div>
          <div className="form-section">
            <input
              type="text"
              id="topic"
              value={topic}
              onChange={updateTopic}
              required
              disabled={loading}
              data-lpignore="true"
              placeholder="Subject"
            />
          </div>
          <div className="form-section">
            <textarea
              id="message"
              value={message}
              onChange={updateMessage}
              required
              disabled={loading}
              data-lpignore="true"
              placeholder="Message"
            />
          </div>
          <div className="form-section contact-form-submit-button-wrapper">
            <button type="submit" disabled={!canSubmit}>
              {loading ? '...' : '>'}
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default ContactPage;
